import { ChangeDetectionStrategy, Component, DestroyRef, inject, Input, OnChanges, OnInit } from '@angular/core';
import { Route } from '@angular/router';
import { NgIf } from '@angular/common';

import { MarketingCategoryComponent } from '@common/marketing-category/desktop/marketing-category.component';
import { HomeModel } from '../home.model';
import { SwiperSlidesComponent } from '@common/swiper/swiper-slides.component';
import { WaterfallComponent } from '@common/waterfall/waterfall.component';
import { DynamicBlockComponent } from '@common/dynamic-block/dynamic-block.component';
import { MarketingCategoryModel } from '@common/marketing-category/marketing-category.model';
import { MiniHomeComponent } from '../../mini-home/desktop/mini-home.component';
import { Constants } from '@helper/constants';
import { BaseLoadMoreComponent } from '../../base-load-more-component';
import { RecordHitsService } from '@service/record-hits.service';
import { SlideItem } from '@common/swiper/model';
import { WaterfallItem } from '@common/waterfall/model';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [
    MarketingCategoryComponent,
    SwiperSlidesComponent,
    WaterfallComponent,
    DynamicBlockComponent,
    NgIf,
    MiniHomeComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent extends BaseLoadMoreComponent implements OnInit, OnChanges {
  private readonly destroyRef = inject(DestroyRef);

  @Input() nameEn?: string;
  @Input() waterfallId?: string;

  constructor(
    public viewModel: HomeModel,
    public categoryViewModel: MarketingCategoryModel,
    public recordHits: RecordHitsService
  ) {
    super(
      viewModel.itemCount,
      Constants.displayCount(viewModel.detectService.isMobileDevice()),
      Constants.waterfallLoadMoreCount(viewModel.detectService.isMobileDevice())
    );
  }

  ngOnInit(): void {
    if (!this.nameEn) {
      // don't get for mini home
      this.viewModel.getHome(this.destroyRef, this.waterfallId);
    }
  }

  ngOnChanges(): void {
    // model inject 設定的數值會一直存在,每次init都以路由參數重新設定.
    this.categoryViewModel.currentBigId.set(this.nameEn ?? '');
  }

  bannerClick(item: SlideItem): void {
    this.recordHits.bannerClick(item.alt, item.hash);
  }

  waterFallClick(item: WaterfallItem): void {
    this.recordHits.waterfallClick(item.id, item.item?.image?.hash ?? '');
  }
}

export const ROUTE: Route[] = [{ path: '', component: HomeComponent }];
